export default __webpack_public_path__ + "static/media/placeholder_dummy2016-restaurant04-de.a552a555.png";